export default "__VITE_ASSET__BASH2lzB__"